import * as React from "react"
const SvgPinRemove = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M14 5.286h-4V7.46L7.25 4.71a.9.9 0 0 1-.187-.275.8.8 0 0 1-.063-.3.88.88 0 0 1 .225-.588.75.75 0 0 1 .6-.262H16q.424 0 .712.287.288.288.288.713a.57.57 0 0 1-.363.562 2.1 2.1 0 0 0-.637.438v6a.97.97 0 0 1-.287.712.97.97 0 0 1-.713.288.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712zm-3 17v-6H7.4q-.625 0-1-.438a1.48 1.48 0 0 1-.375-.987q0-.276.113-.55a1.6 1.6 0 0 1 .362-.525l1.5-1.5v-1.15l-5.9-5.95a.98.98 0 0 1-.287-.688.93.93 0 0 1 .287-.712.95.95 0 0 1 .7-.275q.425 0 .7.275L20.475 20.76q.3.3.287.712a1.02 1.02 0 0 1-.312.713q-.3.275-.7.287a.92.92 0 0 1-.7-.287l-5.9-5.9H13v6a.97.97 0 0 1-.287.712.97.97 0 0 1-.713.288.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712Zm-2.15-8h2.3L10 13.136z" />
  </svg>
)
export default SvgPinRemove
